// Modules
import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import compose from 'lodash/flowRight';
import { getLang } from 'redux-pagan';
import Link from 'react-router/lib/Link';
import cx from 'classnames';
import IntlTelInput from '../../components/IntlTelInput/IntlTelInput';
// Components
import OMInputField from '../../components/OMComponents/OMInputField/OMInputField';
import OMCheckbox from '../../components/OMComponents/OMCheckbox/OMCheckbox';
import UploadAssetWidget from '../../components/UploadAssetWidget/UploadAssetWidget';
import ResendLimitExceededMessage from '../../components/ResendLimitExceededMessage/ResendLimitExceededMessage';
import ResendTimerMessage from '../../components/ResendTimerMessage/ResendTimerMessage';
import ResendButton from '../../components/ResendButton/ResendButton';
import AuthorizationButton from '../../components/AuthorizationButton/AuthorizationButton';
import RegistrationConfirmPhoneModal from './ConfirmPhoneModal';
import RegistrationAgentAdditionalFields from './AgentAdditionalFields';
import RegistrationPasswordsBlock from './PasswordsBlock';
import RegistrationUserNameBlock from './UsernameBlock';
import RegistrationEmailPhoneBlock from './EmailPhoneBlock';
import CloudflareCaptcha from '../../components/CloudflareCaptcha/CloudflareCaptcha';
// Redux
import { hideMessageModal, openMessageModal } from '../../redux/modules/messageModal';
import {
  completeRegistration,
  initRegistration
} from '../../redux/modules/userAuthentication';
// Helper
import appendLocale from '../../helpers/appendLocale';
import CAPTCHA_ACTIONS from '../../helpers/captchaConstants';
import getFullName from '../../helpers/getFullName';
import { authenticationModalType, israelCode, PREFERRED_COUNTRIES, supportEmail } from '../../constants';
import { emailRegexValidation, passwordValidation, phoneRegexValidation } from '../../utils/validate';
import { isTemporaryEmail } from '../../utils/checkers';
import validate from './validate';
import REGISTRATION_FIELDS from './constants';
import { getCompanyImagePublicId } from '../../utils/companyImages';
import { removeImageModifier } from '../../utils/onmapImageModifiers';
// Styles
import * as styles from './RegistrationContainer.scss';

class RegistrationContainer extends Component {
  state = {
    showError: false,
    passwordIsValid: false,
    captcha: null,
    resendCaptcha: null,
    emailIsValid: false,
    phoneIsValid: false,
    isFirstValue: false,
    isCodeModalOpen: false,
    countryData: israelCode,
    isShowCoupon: false,
    resendCounter: 0,
    timerTimeLeft: 0,
    isTimerRunning: false,
    isResendForm: false
  }

  componentDidMount() {
    this.startDate = new Date();
  }

  componentWillReceiveProps(newProps) {
    const { userAuthentication, isRegistrationCheckPhone } = newProps;
    if (
      userAuthentication.loaded &&
      isRegistrationCheckPhone &&
      isRegistrationCheckPhone !== this.props.isRegistrationCheckPhone
    ) {
      this.setState({ isCodeModalOpen: true });
    }
  }

  componentDidUpdate(prevProps) {
    const loadingUserData = this.props.userAuthentication.loading;
    const error = get(this.props, 'userAuthentication.error');
    const prevError = get(prevProps, 'userAuthentication.error');

    if (!loadingUserData && prevError !== error && error) {
      this.fetchReCaptchaToken(null);
    }
  }

  componentWillUnmount() {
    clearInterval(this.resendTimer);
  }

  onSelectFlag = (_, countryData) => {
    this.setState({ countryData: countryData.dialCode });
  };

  getCorrectPhone = (phone, countryData) => {
    if (!phone) {
      return '';
    }
    return countryData === israelCode && phone.startsWith('0')
      ? phone.slice(1)
      : phone;
  };

  getRegistrationCdataPhone = () => {
    const { fields } = this.props;
    const { countryData } = this.state;

    if (!fields.phone) {
      return undefined;
    }

    const phoneNumberData = this.getCorrectPhone(fields.phone, countryData);
    return `+${countryData}${phoneNumberData}`;
  };

  setWrapperRef = (node) => {
    this.formRef = node;
  };

  toggleCodeModal = () => {
    this.setState(prevState => ({ isCodeModalOpen: !prevState }));
  };

  showCorrectPhone = (phone, countryData) => {
    if (!phone) {
      return '';
    }
    const correctPhone = countryData === israelCode && phone.startsWith('0')
      ? phone.slice(1)
      : phone;
    const correctCode = countryData === israelCode
      ? '0'
      : countryData;
    return `${correctCode}${correctPhone}`;
  }

  startTimer = () => {
    clearInterval(this.resendTimer);
    this.resendTimer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timerTimeLeft <= 1) {
          clearInterval(this.resendTimer);
          return { timerTimeLeft: 0, isTimerRunning: false };
        }
        return { timerTimeLeft: prevState.timerTimeLeft - 1 };
      });
    }, 1000);
  };

  submitForm = (value, isResendForm) => {
    const { isRegistrationCheckPhone, locale } = this.props;
    const { captcha, resendCaptcha, countryData } = this.state;
    const {
      email,
      phone,
      password,
      first_name,
      last_name,
      isAgentCheckbox,
      license_number,
      company_name,
      code,
      vechir_v_hatu
    } = value;
    const link = get(value, 'logo.link');
    const angle = get(value, 'logo.angle');
    const phoneNumberData = this.getCorrectPhone(phone, countryData);

    const data = {
      email,
      password,
      captcha: isResendForm ? resendCaptcha : captcha,
      phone: `+${countryData}${phoneNumberData}`,
      first_name: getFullName(first_name, last_name),
      is_agent: isAgentCheckbox,
      license_number,
      company_name,
      vechir_v_hatu,
      ...(isAgentCheckbox ? { profile_img: ((link || angle) ? { link: removeImageModifier(link), angle } : {}) } : {})
    };

    if (!this.state.isCodeModalOpen) {
      const error = this.props.userAuthentication && this.props.userAuthentication.error;
      if (this.state.isTimerRunning && (!error || !error.status)) {
        this.setState({ isCodeModalOpen: true });
        return;
      }

      const initRegistrationData = {
        ...data,
        time_to_complete: new Date() - this.startDate,
        locale
      };
      this.props.initRegistration(initRegistrationData);
      this.setState({
        resendCounter: 0,
        isTimerRunning: true,
        timerTimeLeft: 61
      });
      this.startTimer();
    } else if (isResendForm) {
      const initRegistrationData = {
        ...data,
        time_to_complete: new Date() - this.startDate,
        locale
      };
      this.props.initRegistration(initRegistrationData);
      this.setState((prevState) => ({
        resendCaptcha: null,
        resendCounter: prevState.resendCounter + 1,
        isTimerRunning: prevState.resendCounter < 3,
        timerTimeLeft: prevState.resendCounter < 3 ? 61 : 0
      }));
      this.startTimer();
    } else if (this.state.isCodeModalOpen) {
      const completeRegistrationData = {
        ...data,
        code
      };

      this.props.completeRegistration(completeRegistrationData);
    }
  };

  handleSubmit = (evt, isResendForm) => {
    if (!this.state.captcha) {
      console.warn('Captcha is missing');
      return;
    }

    this.setState({ isResendForm });

    this.props.handleSubmit((value) =>
      this.submitForm(value, isResendForm)
    )(evt);
  };

  handleResendClick = () => {
    if (!this.state.resendCaptcha) {
      console.warn('Captcha is missing');
      return;
    }

    const { fields } = this.props;
    this.submitForm({
      email: fields.email,
      phone: fields.phone,
      password: fields.password,
      first_name: fields.firstName,
      last_name: fields.lastName,
      isAgentCheckbox: fields.isAgentCheckbox,
      license_number: fields.licenseNumber,
      company_name: fields.companyName,
      logo: fields.logo,
      vechir_v_hatu: fields.vechirVHatu
    }, true);
  };

  fetchReCaptchaToken = (token) => {
    this.setState({ captcha: token });
  };

  fetchResendReCaptchaToken = (token) => {
    this.setState({ resendCaptcha: token });
  };

  showCoupon = () => {
    this.setState({ isShowCoupon: true });
  }

  validatePassword = (password) => {
    const result = passwordValidation(password);
    this.setState({ passwordIsValid: result });

    return result;
  };

  validationMark = isInvalid => this.setState({ showError: isInvalid });

  validateEmail = (value) => {
    const email = value.replace(/\s/g, '');

    const emailIsValid = emailRegexValidation(email);
    const phoneIsValid = phoneRegexValidation(value.replace(/\s/g, ''));
    let result = false;
    const { authenticationModalType: modalType } = this.props.userAuthentication;
    const temporaryModal = (modalType === authenticationModalType.UPDATE_TEMPORARY_PROFILE);

    if (emailIsValid || phoneIsValid) {
      result = true;
    } else if (!result) {
      result = false;
    } else if (temporaryModal) {
      result = (this.props.userAuthentication.data.email !== email && !isTemporaryEmail(email));
    }

    this.setState({
      emailIsValid: result ? emailIsValid : false,
      phoneIsValid: result ? phoneIsValid : false,
      ...temporaryModal && { isTemporaryEmail: isTemporaryEmail(email) }
    });

    return result;
  };

  changeImages = (data) => {
    let publicId = null;
    let full = null;
    const image = (data.length) ? data[0] : {};

    if (data.length) {
      publicId = getCompanyImagePublicId(image);
      full = image.full;
    }

    const userImage = {
      link: publicId,
      angle: image.angle || 0,
      full
    };

    this.setState({ isChangeImg: true });
    this.props.changeValue('logo', userImage);
  };

  defineEmailErrorMsg = () => {
    let errorMsg = '';

    if (this.state.isTemporaryEmail) {
      errorMsg = this.props.translate('authenticationPage', 'errorMessageForTemporaryUser');
    } else if (!this.state.emailIsValid) {
      errorMsg = this.props.translate('authenticationPage', 'emailTooltipMessage');
    } else {
      const { error } = this.props.userAuthentication;
      errorMsg = (error && (error.name === 'BadRequestError' || error.message.match(/email/i)))
        ? this.props.translate('authenticationPage', 'errorMessage')
        : '';
    }

    return errorMsg.toString();
  };

  validateInputValue = (value) => {
    if (this.state.isResendForm && (!value || !value.length)) {
      return undefined;
    }
    return value && value.length === 4 ? undefined : 'length-code';
  }

  uploadWidget = ({ meta }) => (
    <div className={styles.widget}>
      <UploadAssetWidget
        openMessageModal={this.props.openMessageModal}
        className={cx({ [styles.inputLogo]: !this.props.isMobile, 'has-error-form': !!meta.error && meta.touched })}
        translate={this.props.translate('uploadWidget')}
        rootTranslate={this.props.translate}
        isMobile={this.props.isMobile}
        uploadInProgress={status => this.setState({ uploadPhotoInProgress: status })}
        updateContent={this.changeImages}
        contentUploaded={this.changeImages}
        suspendedUpload
        userToken={this.props.userToken}
      />
    </div>
  );

  renderResendButton = () => {
    const loadingUserData = (this.props.userAuthentication && this.props.userAuthentication.loading);
    const disabled = this.state.isTimerRunning
      || this.state.resendCounter >= 3
      || loadingUserData
      || !this.state.resendCaptcha;

    const { translate } = this.props;

    if (this.state.resendCounter >= 3) {
      return (
        <ResendLimitExceededMessage className={styles.resendLimitMessage} translate={translate} />
      );
    }
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '30px',
        marginTop: '15px',
        alignItems: 'center'
      }}
      >
        {this.state.resendCounter < 3 && this.state.isTimerRunning && (
          <ResendTimerMessage translate={translate} timeLeft={this.state.timerTimeLeft} />
        )}
        <div className={styles.buttonWrapper}>
          <CloudflareCaptcha
            action={CAPTCHA_ACTIONS.REGISTRATION_INIT}
            cdata={this.getRegistrationCdataPhone()}
            doReset={!this.state.resendCaptcha}
            fetchToken={this.fetchResendReCaptchaToken}
          />
          <ResendButton
            isLoading={loadingUserData}
            disabled={disabled}
            translate={translate}
            isTimerRunning={this.state.isTimerRunning}
            onClick={this.handleResendClick}
          />
        </div>
      </div>
    );
  }

  renderButton = (isConfirmStep) => {
    const loadingUserData = this.props.userAuthentication.loading;
    const { translate } = this.props;
    const { captcha } = this.state;

    return (
      <div className={styles.buttonWrapper}>
         <CloudflareCaptcha
           action={isConfirmStep ? CAPTCHA_ACTIONS.REGISTRATION_COMPLETE : CAPTCHA_ACTIONS.REGISTRATION_INIT}
           cdata={this.getRegistrationCdataPhone()}
           doReset={!captcha}
           fetchToken={this.fetchReCaptchaToken}
         />
         <AuthorizationButton
           onClick={this.state.captcha && this.handleSubmit}
           isLoading={loadingUserData}
           disabled={!captcha}
         >
          {translate('authenticationPage', 'submit')}
        </AuthorizationButton>
      </div>
    );
  };

  renderInput = (data) => {
    const { input, placeholder, type, meta: { touched, error, active } } = data;
    return (
      <span>
        <input
          className={cx({ 'has-error': error && !active && touched, touched }, 'form-control')}
          {...input}
          placeholder={(placeholder || '').replace('*', '')}
          type={type}
        />
        {touched &&
        (error && <span className={styles.required}>{this.props.translate('errorFieldMessages', error)}</span>)}
      </span>
    );
  };

  renderEmailInput = () => {
    const handleChange = (evt) => {
      const { value } = evt.target;
      const isEmpty = !value || (value && value.length === 0);
      const trimmedValue = value ? value.replace(/\s/g, '') : '';

      const emailIsValid = emailRegexValidation(trimmedValue);
      const phoneIsValid = phoneRegexValidation(trimmedValue);

      this.setState((prev) => ({
        ...prev,
        isFirstValue: !!value.length,
        emailIsValid: isEmpty ? false : emailIsValid,
        phoneIsValid: isEmpty ? false : phoneIsValid
      }));
    };

    return (
      <div
        className={cx(
          { [styles.phoneInput]: (this.state.phoneIsValid || !this.state.isFirstValue) }
        )}
        ref={(email) => { this.email = email; }}
      >
        <OMInputField
          isForm
          translate={this.props.translate}
          name={REGISTRATION_FIELDS.EMAIL}
          type="text"
          placeholder={`${this.props.translate('authenticationPage', 'emailField')}`}
          title={this.defineEmailErrorMsg()}
          isInvalid={!!(this.defineEmailErrorMsg() && this.state.showError) || false}
          showHoverTooltip={false}
          fieldIsDirty={isDirty => this.setState(prev => ({ ...prev, emailFieldIsDirty: isDirty }))}
          isMobile={this.props.isMobile}
          onChange={handleChange}
          isValidIfEmpty
          isRtl={this.props.isRtl}
          validationMark={this.validationMark}
          showErrorMessageDesktop
        />
      </div>
    );
  };

  renderPasswordInput = (name) => (
    <div>
      <OMInputField
        isForm
        translate={this.props.translate}
        name={name}
        type="password"
        placeholder={`${this.props.translate('authenticationPage', 'passwordFieldPlaceholder')}`}
        title={`${this.props.translate('authenticationPage', 'passwordTitle')}`}
        validate={this.validatePassword}
        showHoverTooltip={false}
        tooltipMessage={`${this.props.translate('authenticationPage', 'passwordTooltipMessage')}`}
        fieldIsDirty={isDirty => this.setState(prev => ({ ...prev, passwordFieldIsDirty: isDirty }))}
        isMobile={this.props.isMobile}
        hidePasswordTitle={`${this.props.translate('authenticationPage', 'hidePassword')}`}
        revealPasswordTitle={`${this.props.translate('authenticationPage', 'revealPassword')}`}
        isValidIfEmpty
        isRtl={this.props.isRtl}
        showErrorMessageDesktop
      />
    </div>
  );

  renderAgreeCheckbox = (data) => {
    const { input, meta: { touched, error, active } } = data;

    return (
      <div className={styles.formLink}>
        <OMCheckbox
          id="agree"
          field={{ ...input, checked: input.value }}
          notValid={touched && error && !active}
          label={(
            <span>
              <span>{this.props.translate('authenticationPage', 'confirmThatIRead')}</span>
              &nbsp;
              <Link to={appendLocale(this.props.locale, '/terms')} target="_blank">
                {this.props.translate('authenticationPage', 'termsOfUse')}
              </Link>
              &nbsp;
              <Link to={appendLocale(this.props.locale, '/privacy')} target="_blank">
                {this.props.translate('authenticationPage', 'privacy')}
              </Link>
            </span>
          )}
        />
      </div>
    );
  };

  renderAgentCheckbox = ({ input }) => (
    <div className={styles.agentCheckbox}>
      <OMCheckbox
        id="isAgent"
        label={(
          <span>
            <span>{this.props.translate('authenticationPage', 'professionalConfirmation')}</span>
          </span>
        )}
        field={{ ...input, checked: input.value }}
      />
    </div>
  );

  renderPhoneNumber = ({ input, meta: { error, touched } }) => (
    <div className={cx(styles.inputPhone, { 'has-error': error && touched })}>
      <IntlTelInput
        autoPlaceholder={false}
        nationalMode={false}
        containerClassName={cx('intl-tel-input', styles.countrySelect)}
        inputClassName="form-control phone-input"
        fieldName="phone_number"
        value={input.value}
        preferredCountries={PREFERRED_COUNTRIES}
        onPhoneNumberChange={(_, value) => {
          input.onChange(value);
        }}
        onSelectFlag={this.onSelectFlag}
        useMobileFullscreenDropdown={false}
        separateDialCode
      />
      {error && touched && (
        <span className={styles.required}>
          {this.props.translate('errorFieldMessages', 'phone-number')}
        </span>
      )}
    </div>
  );

  render() {
    const { translate, locale, fields, isRtl } = this.props;
    const { isCodeModalOpen, countryData } = this.state;

    return (
      <div className={styles.container}>
        <form onSubmit={this.handleSubmit} ref={this.setWrapperRef}>
          <RegistrationEmailPhoneBlock
            translate={translate}
            renderEmailInput={this.renderEmailInput}
            renderPhoneInput={this.renderPhoneNumber}
            isRtl={isRtl}
          />
          <RegistrationUserNameBlock translate={translate} renderInput={this.renderInput} />
          <RegistrationPasswordsBlock
            translate={translate}
            renderPasswordInput={this.renderPasswordInput}
          />
          <hr />
          <div className={styles.columnBlock}>
            <Field
              name={REGISTRATION_FIELDS.IS_AGENT_CHECKBOX}
              props={{ locale: this.props.locale }}
              component={this.renderAgentCheckbox}
            />
          </div>
          <Field
            name="vechir_v_hatu"
            component="input"
            className={styles.vechir}
          />
          {fields.isAgentCheckbox && (
            <RegistrationAgentAdditionalFields
              locale={locale}
              translate={translate}
              renderInput={this.renderInput}
              uploadWidget={this.uploadWidget}
            />
          )}
          <div className={styles.columnBlock}>
            <Field
              name={REGISTRATION_FIELDS.AGREE}
              props={{ locale: this.props.locale }}
              component={this.renderAgreeCheckbox}
            />
          </div>
          {this.renderButton(false)}
          <RegistrationConfirmPhoneModal
            translate={translate}
            isOpen={isCodeModalOpen}
            onClose={this.toggleCodeModal}
            phone={this.showCorrectPhone(fields.phone, countryData)}
            renderInput={this.renderInput}
            validateInputValue={this.validateInputValue}
          >
            {this.renderButton(true)}
            {this.renderResendButton()}
          </RegistrationConfirmPhoneModal>
        </form>
      </div>
    );
  }
}

RegistrationContainer.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  fields: PropTypes.object,
  userAuthentication: PropTypes.object,
  sendContactUsForm: PropTypes.func,
  openMessageModal: PropTypes.func,
  hideMessageModal: PropTypes.func,
  switchAuthModalType: PropTypes.func,
  userData: PropTypes.object,
  isMessageModalOpen: PropTypes.bool,
  validatePassword: PropTypes.func,
  usage: PropTypes.string,
  isRtl: PropTypes.bool,
  isRegistrationCheckPhone: PropTypes.bool,
  isContactUsModalOpen: PropTypes.bool,
  hideContactUsModal: PropTypes.func,
  authenticateUser: PropTypes.func,
  openAuthenticationModal: PropTypes.func,
  socialNetworkAuthentication: PropTypes.func,
  authenticateUserByNumber: PropTypes.func,
  handleSubmit: PropTypes.func,
  checkPhone: PropTypes.func,
  changeValue: PropTypes.func,
  initRegistration: PropTypes.func,
  completeRegistration: PropTypes.func,
  isPageForRealtor: PropTypes.bool,
  userToken: PropTypes.string
};

const selector = formValueSelector('registrationForm');
const changeValue = (name, value) => change('registrationForm', name, value);

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static'),
  locale: state.lang.locale,
  userToken: get(state, 'userAuthentication.data.access_token'),
  isMobile: state.windowDimentions.isMobile,
  userData: state.userAuthentication.data,
  isRegistrationCheckPhone: state.userAuthentication.isRegistrationCheckPhone,
  userAuthentication: state.userAuthentication,
  fields: {
    email: selector(state, REGISTRATION_FIELDS.EMAIL),
    phone: selector(state, REGISTRATION_FIELDS.PHONE),
    password: selector(state, REGISTRATION_FIELDS.PASSWORD),
    repeatPassword: selector(state, REGISTRATION_FIELDS.REPEAT_PASSWORD),
    firstName: selector(state, REGISTRATION_FIELDS.FIRST_NAME),
    lastName: selector(state, REGISTRATION_FIELDS.LAST_NAME),
    isAgentCheckbox: selector(state, REGISTRATION_FIELDS.IS_AGENT_CHECKBOX),
    logo: selector(state, REGISTRATION_FIELDS.LOGO),
    companyName: selector(state, REGISTRATION_FIELDS.COMPANY_NAME),
    licenseNumber: selector(state, REGISTRATION_FIELDS.LICENSE_NUMBER),
    coupon: selector(state, REGISTRATION_FIELDS.COUPON),
    agree: selector(state, REGISTRATION_FIELDS.AGREE),
    code: selector(state, REGISTRATION_FIELDS.CODE),
    vechirVHatu: selector(state, REGISTRATION_FIELDS.VECHIR_V_HATU)
  }
});

const mapDispatchToProps = {
  changeValue,
  openMessageModal,
  hideMessageModal,
  initRegistration,
  completeRegistration
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'registrationForm',
    validate
  })
)(RegistrationContainer);
